// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RadiusBottomleftOutlinedSvg from "@ant-design/icons-svg/es/asn/RadiusBottomleftOutlined";
import AntdIcon from '../components/AntdIcon';

var RadiusBottomleftOutlined = function RadiusBottomleftOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RadiusBottomleftOutlinedSvg
  }));
};

RadiusBottomleftOutlined.displayName = 'RadiusBottomleftOutlined';
export default React.forwardRef(RadiusBottomleftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/RadiusBottomleftOutlined.js
// module id = 1663
// module chunks = 0